import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wind-mid",
  "use": "icon-wind-mid-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-wind-mid\"><path d=\"M6.983 9.582a1.78 1.78 0 0 1-1.639-.423c-.964 1.108-2.16 4.186-2.49 4.392-.262.542-3.668-.632-2.671-3.216C1.774 7.83 3.873 7.379 4.86 7.314c.178-.555.62-.991 1.179-1.16-.317-1.337-2.531-4.17-2.538-4.577-.33-.503 2.427-2.82 4.131-.637 1.366 2.723.6 4.793.15 5.633a1.772 1.772 0 0 1 .502 1.69c1.397.314 4.779-.223 5.13-.037.6-.046 1.297 3.488-1.438 3.925-3.02-.119-4.463-1.763-4.993-2.57z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol